var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoniter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 92,
    viewBox: "0 0 130 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_16930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4405 88.9201C50.4616 88.5107 50.7263 84.8156 50.7263 84.8156V78.0111H72.9607V84.812C72.9607 84.812 73.2254 88.5072 76.2465 88.9166C76.4042 88.9426 76.5473 89.0242 76.6502 89.1465C76.7531 89.2688 76.8089 89.4238 76.8076 89.5836V90.1906C76.8081 90.2533 76.7961 90.3155 76.7723 90.3735C76.7485 90.4315 76.7135 90.4842 76.6691 90.5286C76.6248 90.5729 76.5721 90.608 76.5141 90.6318C76.4561 90.6555 76.3939 90.6676 76.3312 90.6671H47.3488C47.2861 90.6676 47.2239 90.6555 47.1659 90.6318C47.1079 90.608 47.0552 90.5729 47.0108 90.5286C46.9665 90.4842 46.9314 90.4315 46.9076 90.3735C46.8839 90.3155 46.8719 90.2533 46.8723 90.1906V89.5836C46.8721 89.4234 46.9293 89.2683 47.0336 89.1466C47.1378 89.0249 47.2822 88.9446 47.4405 88.9201Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.05878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.967 15.2676H9.72659C8.78125 15.2676 8.01489 16.034 8.01489 16.9793V77.15C8.01489 78.0953 8.78125 78.8617 9.72659 78.8617H113.967C114.913 78.8617 115.679 78.0953 115.679 77.15V16.9793C115.679 16.034 114.913 15.2676 113.967 15.2676Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.05878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.873 18.5216H10.8279V75.6076H112.873V18.5216Z",
    fill: "url(#paint0_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4441 88.92H76.2536",
    stroke: "#333333",
    strokeWidth: 1.05878,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.898 18.5216H10.842V22.3756H112.898V18.5216Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.124 21.2604C14.5294 21.2604 14.8581 20.9317 14.8581 20.5263C14.8581 20.1208 14.5294 19.7922 14.124 19.7922C13.7186 19.7922 13.3899 20.1208 13.3899 20.5263C13.3899 20.9317 13.7186 21.2604 14.124 21.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2121 21.2604C17.6175 21.2604 17.9462 20.9317 17.9462 20.5263C17.9462 20.1208 17.6175 19.7922 17.2121 19.7922C16.8067 19.7922 16.478 20.1208 16.478 20.5263C16.478 20.9317 16.8067 21.2604 17.2121 21.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2968 21.2604C20.7023 21.2604 21.0309 20.9317 21.0309 20.5263C21.0309 20.1208 20.7023 19.7922 20.2968 19.7922C19.8914 19.7922 19.5627 20.1208 19.5627 20.5263C19.5627 20.9317 19.8914 21.2604 20.2968 21.2604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2117 27.1507H21.0308V29.9353H26.2117V27.1507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.3431 27.1507H30.5176V29.9353H69.3431V27.1507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2117 31.9611H21.0308V34.7457H26.2117V31.9611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.834 31.9611H30.5176V34.7457H104.834V31.9611Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.411 43.3995H90.854C88.5833 43.3995 86.7424 45.2403 86.7424 47.5111V65.2633C86.7424 67.5341 88.5833 69.3749 90.854 69.3749H121.411C123.681 69.3749 125.522 67.5341 125.522 65.2633V47.5111C125.522 45.2403 123.681 43.3995 121.411 43.3995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.081 41.0314H88.5247C86.2539 41.0314 84.4131 42.8722 84.4131 45.143V62.8952C84.4131 65.166 86.2539 67.0068 88.5247 67.0068H119.081C121.352 67.0068 123.193 65.166 123.193 62.8952V45.143C123.193 42.8722 121.352 41.0314 119.081 41.0314Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.882319,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 47.7864H89.4001V49.5898H118.725V47.7864Z",
    fill: "url(#paint1_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 51.6263H89.4001V53.4297H118.725V51.6263Z",
    fill: "url(#paint2_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 55.4661H89.4001V57.2695H118.725V55.4661Z",
    fill: "url(#paint3_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 59.306H89.4001V61.1094H118.725V59.306Z",
    fill: "url(#paint4_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3786 63.8693L53.479 56.2143L56.5459 52.251L62.3234 56.719L71.5348 43.8019L75.6146 46.71L63.3786 63.8693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.626 0.441162H76.3702C75.2694 0.441162 74.2137 0.87845 73.4354 1.65681C72.657 2.43516 72.2197 3.49083 72.2197 4.59159V21.7897C72.2197 22.8905 72.657 23.9462 73.4354 24.7246C74.2137 25.5029 75.2694 25.9402 76.3702 25.9402H95.6435V32.7199L102.423 25.9402H124.626C125.727 25.9402 126.782 25.5029 127.561 24.7246C128.339 23.9462 128.776 22.8905 128.776 21.7897V4.60219C128.778 4.05626 128.671 3.51543 128.463 3.01066C128.256 2.50588 127.95 2.04708 127.564 1.66055C127.179 1.27403 126.721 0.967357 126.217 0.758116C125.712 0.548876 125.172 0.44116 124.626 0.441162Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.882319,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.709 3.47992H78.3815C76.7072 3.47992 75.3499 4.83723 75.3499 6.51157V19.8699C75.3499 21.5442 76.7072 22.9015 78.3815 22.9015H122.709C124.384 22.9015 125.741 21.5442 125.741 19.8699V6.51157C125.741 4.83723 124.384 3.47992 122.709 3.47992Z",
    fill: "url(#paint5_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6435 15.8818C97.1307 15.8818 98.3364 14.6761 98.3364 13.1889C98.3364 11.7017 97.1307 10.4961 95.6435 10.4961C94.1563 10.4961 92.9507 11.7017 92.9507 13.1889C92.9507 14.6761 94.1563 15.8818 95.6435 15.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.407 15.8818C107.895 15.8818 109.1 14.6761 109.1 13.1889C109.1 11.7017 107.895 10.4961 106.407 10.4961C104.92 10.4961 103.715 11.7017 103.715 13.1889C103.715 14.6761 104.92 15.8818 106.407 15.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.168 15.8818C118.656 15.8818 119.861 14.6761 119.861 13.1889C119.861 11.7017 118.656 10.4961 117.168 10.4961C115.681 10.4961 114.476 11.7017 114.476 13.1889C114.476 14.6761 115.681 15.8818 117.168 15.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8825 15.8818C86.3697 15.8818 87.5754 14.6761 87.5754 13.1889C87.5754 11.7017 86.3697 10.4961 84.8825 10.4961C83.3953 10.4961 82.1897 11.7017 82.1897 13.1889C82.1897 14.6761 83.3953 15.8818 84.8825 15.8818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68457 67.6562H41.4478C41.874 67.6562 42.2961 67.5722 42.6898 67.4089C43.0836 67.2457 43.4413 67.0065 43.7425 66.7049C44.0437 66.4034 44.2826 66.0455 44.4454 65.6515C44.6081 65.2576 44.6917 64.8355 44.6912 64.4092V50.9592C44.6917 50.5329 44.6081 50.1108 44.4454 49.7169C44.2826 49.323 44.0437 48.965 43.7425 48.6635C43.4413 48.3619 43.0836 48.1227 42.6898 47.9595C42.2961 47.7962 41.874 47.7122 41.4478 47.7122H26.3566V42.4183L21.0627 47.7122H3.68457C3.25834 47.7122 2.8363 47.7962 2.44256 47.9595C2.04882 48.1227 1.69112 48.3619 1.38989 48.6635C1.08867 48.965 0.849822 49.323 0.687033 49.7169C0.524244 50.1108 0.4407 50.5329 0.441164 50.9592V64.4092C0.4407 64.8355 0.524244 65.2576 0.687033 65.6515C0.849822 66.0455 1.08867 66.4034 1.38989 66.7049C1.69112 67.0065 2.04882 67.2457 2.44256 67.4089C2.8363 67.5722 3.25834 67.6562 3.68457 67.6562Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.882319,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18792 65.2775H39.8595C41.1694 65.2775 42.2312 64.2156 42.2312 62.9058V52.4592C42.2312 51.1493 41.1694 50.0875 39.8595 50.0875L5.18792 50.0875C3.87808 50.0875 2.81626 51.1493 2.81626 52.4592V62.9058C2.81626 64.2156 3.87808 65.2775 5.18792 65.2775Z",
    fill: "url(#paint6_linear_752_16930)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3565 59.7894C27.5201 59.7894 28.4635 58.8461 28.4635 57.6824C28.4635 56.5188 27.5201 55.5754 26.3565 55.5754C25.1928 55.5754 24.2495 56.5188 24.2495 57.6824C24.2495 58.8461 25.1928 59.7894 26.3565 59.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9393 59.7894C19.1029 59.7894 20.0462 58.8461 20.0462 57.6824C20.0462 56.5188 19.1029 55.5754 17.9393 55.5754C16.7756 55.5754 15.8323 56.5188 15.8323 57.6824C15.8323 58.8461 16.7756 59.7894 17.9393 59.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52202 59.7894C10.6857 59.7894 11.629 58.8461 11.629 57.6824C11.629 56.5188 10.6857 55.5754 9.52202 55.5754C8.35836 55.5754 7.41504 56.5188 7.41504 57.6824C7.41504 58.8461 8.35836 59.7894 9.52202 59.7894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7774 59.7894C35.941 59.7894 36.8844 58.8461 36.8844 57.6824C36.8844 56.5188 35.941 55.5754 34.7774 55.5754C33.6137 55.5754 32.6704 56.5188 32.6704 57.6824C32.6704 58.8461 33.6137 59.7894 34.7774 59.7894Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_752_16930",
    x1: 22.0651,
    y1: 86.8484,
    x2: 101.633,
    y2: 7.28086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_752_16930",
    x1: 7517.65,
    y1: 296.574,
    x2: 9954.25,
    y2: 296.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_752_16930",
    x1: 7517.65,
    y1: 320.035,
    x2: 9954.25,
    y2: 320.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_752_16930",
    x1: 7517.65,
    y1: 343.515,
    x2: 9954.25,
    y2: 343.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_752_16930",
    x1: 7517.65,
    y1: 366.976,
    x2: 9954.25,
    y2: 366.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_752_16930",
    x1: 75.3499,
    y1: 13.189,
    x2: 125.741,
    y2: 13.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_752_16930",
    x1: -585635,
    y1: -7411.25,
    x2: -590036,
    y2: -7411.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_16930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.221,
    height: 91.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoniter);
export default __webpack_public_path__ + "static/media/moniter.bed726afc06e5fac9c41396affa71e9a.svg";
export { ForwardRef as ReactComponent };